import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';
import { OrganizationUserAccessTypes } from '@interfaces/organizationUser';

export const FETCH_ORG_USERS_WITH_ACCESS_TO_ENTITY = gql`
  query fetchUser($userId: SafeString!) {
    fetchUser(input: { userId: $userId }) {
      user {
        id: stringId
        organization { id translatedName { ${TRANSLATED_STRING_FIELDS} } }
        firstName
        lastName
        entityName
        accessibleBy (input: { excludeRepCodeUsers: true }) {
          organizationUser { id firstName lastName email }
          role { id }
          accounts { id }
          relation
        }
      }
    }
  }
`;

export const ADD_ENTITY_TO_ORG_USER = gql`
  mutation addEntityToOrganizationUser(
    $input: AddEntityToOrganizationUserInput!
  ) {
    addEntityToOrganizationUser(input: $input) {
      organizationUser {
        id
      }
    }
  }
`;

export const REMOVE_ENTITY_FROM_ORG_USER = gql`
  mutation removeEntityFromOrganizationUser(
    $input: RemoveEntityFromOrganizationUserInput!
  ) {
    removeEntityFromOrganizationUser(input: $input) {
      organizationUser {
        id
      }
    }
  }
`;

const MAX_SEARCH_RESULTS = 12;
export const SEARCH_ORG_USERS = gql`
  query searchOrgUsers($query: String!, $childrenForOrganizationId: ObjectID!, $parentForOrganizationId: ObjectID!) {
    fetchOrganizationUsers(input: {
      filter: { searchText: $query, childrenForOrganizationId: $childrenForOrganizationId, parentForOrganizationId: $parentForOrganizationId, accessType: ${OrganizationUserAccessTypes.ENTITY} }
      pagination: { perPage: ${MAX_SEARCH_RESULTS} },
    }) {
      totalCount
      organizationUsers {
        id
        firstName
        lastName
        email
        role { id translatedName { ${TRANSLATED_STRING_FIELDS} } }
      }
    }
  }
`;
